import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { ReportingLine, SalesTeamNode } from './sales-team-management.model';

@Injectable({
  providedIn: 'root',
})
export class SalesTeamManagementApi {
  private readonly _baseUrl: string = 'sales-team/';

  constructor(private _apiService: ApiService) {}

  /** The whole tree in one unpaginated call: the people who report directly to Admin, nested. Admin only. */
  hierarchy(): Observable<SalesTeamNode[]> {
    return this._apiService.get<SalesTeamNode[]>(`${this._baseUrl}hierarchy/`);
  }

  /** Assigns or changes one employee's manager (201 new, 200 changed). PATCH is not supported. */
  assignManager(employeeId: string, managerId: string): Observable<ReportingLine> {
    return this._apiService.put<ReportingLine>(`${this._baseUrl}reporting-lines/${employeeId}/`, {
      manager: managerId,
    });
  }

  /** Puts the employee back under Admin. Their own reports stay under them. */
  removeManager(employeeId: string): Observable<void> {
    return this._apiService.delete<void>(`${this._baseUrl}reporting-lines/${employeeId}/`);
  }

  /** Assigns 1 to 200 employees to one manager. All or nothing: one failure saves none. */
  bulkAssign(managerId: string, employeeIds: string[]): Observable<ReportingLine[]> {
    return this._apiService.post<ReportingLine[]>(`${this._baseUrl}reporting-lines/bulk-assign/`, {
      manager: managerId,
      employees: employeeIds,
    });
  }
}
